const postfixes = ['б', 'Кб', 'Мб', 'Гб', 'Тб'];

/**
 * Показывает размер файла в сокращенном виде с пост-фиксом
 */
export const convertBytes = (bytes?: number | string | null): string => {
    const postfixesLength = postfixes.length - 1;

    let result: number = parseInt(`${bytes}`, 10);

    if ((!result && result !== 0) || result < 0) {
        return '';
    }

    let index = 0;

    while (result >= 1024 && index < postfixesLength) {
        result /= 1024;
        index += 1;
    }

    if (result >= 1000) {
        if (index >= postfixesLength) {
            return '';
        }

        result = 1;
        index += 1;
    }

    const postfix = postfixes[index];

    result = Math.round(result * 10) / 10;

    return `${result.toString().split('.').join(',')} ${postfix}`;
};
